import { Injectable } from '@angular/core';
import {CommonService} from './common.service';
// @ts-ignore
import Encoding from 'encoding-japanese';

@Injectable({
  providedIn: 'root'
})
export class CsvService {
  csvData: any; // 新しいファイルが読み込まれるまで保持。
  separatedCsvData: any[] = [];
  constructor(private commonService: CommonService) { }

  // JSON形式読込
  /**
   *
   * @param file
   * @param propertiesObj
   */
  async csvJSON(file: File, propertiesObj: any = {}) {
    const includesProperties = !Object.keys(propertiesObj).length;
    console.log('includesProperties: ' + includesProperties);
    let properties:any = [];
    const csv = await this.fileToText(file);
    const lines = csv.split(/\r\n|\n|\r/);
    const result: any[] = [];
    const i_start = Object.keys(propertiesObj).length ? 0 : 1;
    if (includesProperties) {
      properties = lines[0].split(',');
      console.log('properties: ' + properties);
      for (let i = 0; i < properties.length; i++) {
        if (properties[i]) {
          propertiesObj[properties[i]] = i;
        }
      }
    }
    for (let i = i_start; i < lines.length; i++) {
      const currentline = lines[i].split(',');
      if (currentline && currentline.length > 4) {
        const obj:any = {};
        Object.keys(propertiesObj).forEach((key: string) => {
          obj[key] = this.commonService.numToNumber(currentline[propertiesObj[key]]);
          obj[key] = this.commonService.boolToBoolean(currentline[propertiesObj[key]]);
        });
        result.push(obj);
      }
    }
    if (includesProperties) {
      return {properties: properties, result: result};
    }
    return result;
  }

  /**
   * csvファイル読み込み処理
   * @param file csvファイル
   * @param propertiesArray csvファイルのカラムの並びとプロパティ名の対応を表す配列
   * @param omitFirstRow 最初の行を省くかどうか（最初の行がヘッダである場合、省きたい）
   * @param from_encoding csvファイルの変換前の文字コード
   * @param to_encoding csvファイルの変換後の文字コード
   */
  async csvJSON2(file: File, propertiesArray: string[] = [], omitFirstRow = false,
    from_encoding = 'SJIS', to_encoding = 'UNICODE') {
    const includesProperties = !propertiesArray.length;
    console.log('includesProperties: ' + includesProperties);
    const csv = await this.fileToText(file, from_encoding, to_encoding);
    const lines = csv.split(/\r\n|\n|\r/);
    if (omitFirstRow && lines.length) {
      lines.shift();
    }
    const result: any[] = [];
    const i_start = propertiesArray.length ? 0 : 1;
    if (includesProperties) {
      propertiesArray = lines[0].split(',');
    }
    for (let i = i_start; i < lines.length; i++) {
      const currentline = lines[i].split(',');
      if (currentline && currentline.length > 4) {
        const obj:any = {};
        propertiesArray.forEach((property, index) => {
          obj[property] = this.commonService.numToNumber2(currentline[index]);
          // obj[property] = this.commonService.boolToBoolean(currentline[index]);
        });
        result.push(obj);
      }
    }
    return result;
  }

  /**
   *
   * @param file
   * @param from_encoding
   * @param to_encoding
   */
  fileToText(file: File, from_encoding = 'SJIS', to_encoding = 'UNICODE'): Promise<string> {
    const reader = new FileReader();
    reader.readAsBinaryString(file);
    return new Promise((resolve, reject) => {
      reader.onload = (event: any) => {
        const result = event.target.result;
        const sjisArray = this.str2Array(result);
        // @ts-ignore
        const uniArray = Encoding.convert(sjisArray, {
          from: from_encoding, // from_encoding
          to: to_encoding, // to_encoding
        });
        // @ts-ignore
        const result2 = Encoding.codeToString(uniArray);
        // @ts-ignore
        resolve(result2);
      };
      reader.onerror = () => {
        reject(reader.error);
      };
    });
  }

  // 文字列を配列に変換
  /**
   *
   * @param str
   */
  str2Array(str: string) {
    const array = [];
    const il = str.length;
    for (let i = 0; i < il; i++) {
      array.push(str.charCodeAt(i));
    }
    return array;
  }

  /**
   *
   * @param eventId
   */
  getSelectedIndex(eventId: string) {
    if (this.separatedCsvData && this.separatedCsvData.length > 0) {
      const selected = this.separatedCsvData.findIndex((row: any) => {
        return row.relatedLotEventId === eventId || row?.relatedLotEventIdList?.includes(eventId);
      });
      console.log(selected);
      return selected;
    }
    return null;
  }

  /**
   *
   * @param arr any[]：{prop1: value1, prop2: value2,...}[]。csvとして出力したいデータ。
   * @param properties arrのプロパティを他の文字列に置換。propertiesの順番でcsvデータも出力。nameがないか空の文字列の場合、見出し行（列）なしのcsvが出力される。
   * @param indexDirection 見出しの向きを水平にするか垂直にするか。
   * @param fileName 出力するファイルの名前。'.csv'はつけてもつけなくても可。
   */
  async exportCsv(arr: any[], properties: {prop: string, name?: string}[], indexDirection: 'horizontal' | 'vertical' = 'horizontal', fileName = '') {
    const ext = '.csv';
    if (fileName === '') {fileName = this.commonService.getDateWithString() + '_' + this.commonService.getTimeWithString();}
    if (fileName.toLowerCase().indexOf(ext) !== fileName.length - ext.length) {fileName += ext;}
    const mat: any[] = [];
    for (let propertyIndex = 0; propertyIndex < properties.length; propertyIndex++) {
      if (indexDirection === 'horizontal') {
        if (!mat[0]?.length) {mat[0] = [];}
        if (properties[0]?.name) {
          mat[0].push(
            properties[propertyIndex].name
          );
        }
      } else {
        mat.push(
          properties[0]?.name
            ? [properties[propertyIndex].name]
            : []
        );
      }
    }
    for (let arrIndex = 0; arrIndex < arr.length; arrIndex++) {
      for (let propertyIndex = 0; propertyIndex < properties.length; propertyIndex++) {
        const index
          = indexDirection === 'horizontal'
            ? arrIndex + 1
            : propertyIndex;
        if (indexDirection === 'horizontal' && !mat[index]?.length) {mat[index] = [];}
        Object.keys(arr[arrIndex]).some((key: string) => key === properties[propertyIndex].prop)
          ? mat[index].push(arr[arrIndex][properties[propertyIndex].prop])
          : mat[index].push('empty');
      }
    }
    const csvString = mat.reduce((prev: string, currentRow: any[]) => {
      prev += currentRow.reduce((prev2: any, currentCell: any) => {
        prev2 += '"' + currentCell + '",';
        return prev2;
      }, '') + '\r\n';
      return prev;
    }, '');

    console.log(fileName);
    console.log(csvString);

    // CSV ファイルは `UTF-8 BOM有り` で出力する
    // そうすることで Excel で開いたときに文字化けせずに表示できる
    const bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
    const fileType = 'text/csv';
    // CSVファイルを出力するために Blob 型のインスタンスを作る
    const blob = new Blob([bom, csvString], { type: fileType });

    const blobURL = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', blobURL);
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    console.log('link', link);
    link.click();
    link.remove();
    URL.revokeObjectURL(blobURL);

    // this.loading = false;
    // this.btnCSVisDisabled = false;
  }
}
